export const setCookie = (name: string, value?: string) => {
  document.cookie = `${name}=${value};path=/`;
};

export const getCookie = (name: string) => {
  var _name = `${name}=`;
  var arr = document.cookie.split(';');
  const a = arr.find((a) => a.startsWith(_name));
  if (a) {
    return a.split('=')[1];
  }
  return '';
};

/**
 * 检查JWT令牌是否过期
 * 通过检查存储在cookie中的security_context_exp值来判断JWT令牌是否已过期
 * 如果cookie中没有找到security_context_exp，或者其值小于当前时间，则认为令牌已过期
 *
 * @returns {boolean} 如果令牌已过期返回true，否则返回false
 */
export const isJwtExpired = (): boolean => {
  // 获取所有cookie，拆分为键值对数组
  const cookies = document.cookie.split('; ');
  let securityContextExp = '';
  // 遍历cookie数组，寻找security_context_exp键
  for (const cookie of cookies) {
    const [key, value] = cookie.split('=');
    // 当找到security_context_exp时，存储其值并结束循环
    if (key.trim() === 'security_context_exp') {
      securityContextExp = value;
      break;
    }
  }

  // 如果没有找到security_context_exp，打印日志并认为令牌已过期
  if (!securityContextExp) {
    console.log('No security_context_exp found in cookies.');
    return true;
  }
  if (!Number(securityContextExp)) {
    return true;
  }
  // 获取当前时间戳，转换为秒
  const now = Math.floor(Date.now() / 1000);
  // 比较security_context_exp值与当前时间，判断令牌是否过期
  return Number(securityContextExp) < now;
};
